import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import '@fontsource/inter/300.css';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import App from './App';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { ThemeProvider } from './theme';
import reportWebVitals from './reportWebVitals';
import "bootstrap/dist/css/bootstrap.min.css";
import '@flaticon/flaticon-uicons/css/all/all.css';
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { runStartupProbe } from './lib/startupProbe';
import { Capacitor } from "@capacitor/core";
import { StatusBar, Style } from "@capacitor/status-bar";

async function configureStatusBar() {
  if (!Capacitor.isNativePlatform()) return;

  document.documentElement.classList.add("native-app");

  await StatusBar.setOverlaysWebView({
    overlay: false,
  });

  await StatusBar.setBackgroundColor({
    color: "#F3F0F8",
  });

  await StatusBar.setStyle({
    style: Style.Dark,
  });
}

configureStatusBar();
// Run once at app start – check backend reachability & CORS before user tries to sign in
runStartupProbe();

const queryClient = new QueryClient();

<script src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/js/bootstrap.bundle.min.js"></script>

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId="386838594883-a8he0srbr8m5egv07biuoled32hti3i9.apps.googleusercontent.com">
      <ThemeProvider>
        <QueryClientProvider client={queryClient}>
          <App />
        </QueryClientProvider>
      </ThemeProvider>
    </GoogleOAuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
